import api from '../utils/api';

export async function uploadVisualAsset(agentId, assetType, file) {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await api.post(`/agents/${agentId}/visual-assets/${assetType}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteVisualAsset(agentId, assetType) {
  const { data } = await api.delete(`/agents/${agentId}/visual-assets/${assetType}`);
  return data;
}

export async function getVisualAssetPreview(agentId, assetType) {
  const { data } = await api.get(`/agents/${agentId}/visual-assets/${assetType}/preview`);
  return data;
}
